module.exports = __webpack_public_path__ + "static/img/banner-csr-14.31fd9ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-csr-14.jpg
// module id = YP2g
// module chunks = 98